import { AxiosResponse } from "axios";
import { setClaimsJWT } from "../../feat/oauth/oauth.slice";
import { logInterResponse } from "./logInterResponse";
export const comboInterceptorResponse = async (response: AxiosResponse) => {
  if (!response) {
    return response;
  }
  logInterResponse(response);
  setClaimsJWT(response.headers["x-eventr-claims"]);

  return response;
};
